// extracted by mini-css-extract-plugin
module.exports =  {"root":"TokenUsageBanner-module__root--MuwMj","icon":"TokenUsageBanner-module__icon--xsoFh","message":"TokenUsageBanner-module__message--kXeFs"};